import React from 'react';

const ProfileDetail = ({ tutorDetails }) => {
  return (
    <>
      <div className="flex w-fit gap-2">
        {tutorDetails.testPrepCertifiedACT ? (
          <div className="flex items-center gap-2 rounded-full bg-[#66CDCC] px-3 py-2">
            <div className="w-8 md:w-12">
              <img src="/images/act.png" alt="" className="w-full object-contain" />
            </div>
            <p className="tracking[-0.36px] font-[Fredoka] text-[16px] font-semibold leading-normal text-[#012E33] md:text-[18px]">
              Test Prep
            </p>
          </div>
        ) : (
          ''
        )}
        {tutorDetails.testPrepCertifiedSAT ? (
          <div className="flex items-center gap-2 rounded-full bg-[#66CDCC] p-2 px-3">
            <div className="w-8 md:w-12">
              <img src="/images/sat.png" alt="" className="w-full object-contain" />
            </div>
            <p className="tracking[-0.36px] font-[Fredoka] text-[16px] font-semibold leading-normal text-[#012E33] md:text-[18px]">
              Test Prep
            </p>
          </div>
        ) : (
          ''
        )}
      </div>
      <div className="flex items-start justify-between pb-4 pt-2 md:px-3">
        <div className="flex flex-col gap-2">
          <h1 className="text-[24px] font-bold leading-none -tracking-[0.8px] text-[#012E33] md:text-[30px] lg:text-[40px]">
            {tutorDetails?.name || 'Isabel C.'}
          </h1>
          <p className="text-lg leading-normal -tracking-[0.36px] text-[#678285]">Houston, Texas</p>
        </div>
        <div
          title="hourly rate"
          className="text-[24px] font-normal -tracking-[0.8px] text-[#012E33] md:text-[30px] lg:text-[40px]"
        >
          {`$${tutorDetails?.hourlyRate}/hr`}
        </div>
      </div>
      <div className="flex flex-col items-start justify-between gap-2 pb-6 md:px-3">
        <div className="flex items-center gap-2">
          <div className="tooltip">
            <img
              alt="education"
              src="/images/icons/education-black.svg"
              className="h-8 w-8 object-contain "
            />
            <span className="tooltiptext w-60 text-xs md:w-72">
              This tutor helps students work on the following academic class subjects
            </span>
          </div>
          <span className="w-[calc(100%-40px)] text-lg font-normal leading-tight -tracking-[0.36px] text-[#012E33]">
            {tutorDetails?.subjects || 'Italian'}
          </span>
        </div>
        <div className="flex items-center gap-2">
          <div className="tooltip">
            <img
              alt="education"
              src="/images/icons/ChalkboardTeacher.svg"
              className="h-8 w-8 object-contain "
            />
            <span className="tooltiptext w-60 text-xs md:w-72">
              This tutor coaches individuals in the following areas
            </span>
          </div>
          <span className="w-[calc(100%-40px)] text-lg font-normal leading-tight -tracking-[0.36px] text-[#012E33]">
            {tutorDetails?.coachingAreas || 'Italian'}
          </span>
        </div>
        {/* <div className="flex flex-row-reverse gap-2 md:flex-row items-center md:gap-[15px] text-[#678285]">
                    <span className='font-normal mt-1 text-base -leading-[0.32px] self-end'>{`${tutorDetails?.rating || 4}/5`}</span>
                    <StarRating rating={tutorDetails?.rating || 4} />
                    <span className='hidden md:block font-normal text-base underline -leading-[0.32px]'>77 Ratings</span>
                </div> */}
      </div>

      <p className="pb-6 text-lg font-normal leading-tight -tracking-[0.36px] text-[#678285] md:px-3 md:pb-[69px]">
        {tutorDetails.bio}
      </p>
    </>
  );
};

export default ProfileDetail;
